import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Coquille commune aux écrans publics (connexion, inscription, mot de passe
 * oublié) : panneau de marque à gauche, formulaire à droite, sélecteur de
 * langue identique à celui de l'en-tête de l'app.
 */
const AuthLayout = ({ title, subtitle, children, footer }) => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex min-h-screen bg-canvas" dir={i18n.dir()}>
      {/* Panneau de marque — masqué sur mobile pour laisser la place au formulaire */}
      <div className="hidden w-[44%] shrink-0 flex-col justify-between bg-brand p-10 lg:flex">
        <img src="/nibras.png" alt="Nibras" className="h-10 w-auto self-start object-contain" />
        <div>
          <p className="max-w-sm text-2xl font-semibold leading-snug text-white">
            {t('login.subtitle')}
          </p>
          <p className="mt-2 text-sm font-medium text-white/85">nibrass.app</p>
          <p className="mt-8 text-xs font-medium text-white/70">© {new Date().getFullYear()} Nibras</p>
        </div>
      </div>

      <div className="relative flex flex-1 items-center justify-center px-4 py-12 sm:px-6">
        <div className="absolute top-4 end-4 flex items-center rounded-lg border border-line bg-surface p-0.5">
          {['fr', 'ar'].map((lng) => (
            <button
              key={lng}
              type="button"
              onClick={() => changeLanguage(lng)}
              className={`rounded-md px-2.5 py-1 text-2xs font-semibold uppercase transition-colors ${
                i18n.language.startsWith(lng)
                  ? 'bg-brand-subtle text-brand-ink'
                  : 'text-ink-subtle hover:text-ink'
              }`}
            >
              {lng}
            </button>
          ))}
        </div>

        <div className="w-full max-w-sm">
          {/* Sur mobile, le panneau de marque est masqué : on rappelle logo et accroche */}
          <div className="mb-8 lg:hidden">
            <img src="/nibras.png" alt="Nibras" className="h-11 w-auto object-contain" />
            <p className="mt-3 text-sm text-ink-muted">{t('login.subtitle')}</p>
          </div>

          <h1 className="text-xl font-semibold tracking-tight text-ink">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-ink-muted">{subtitle}</p>}

          <div className="mt-7">{children}</div>

          {footer && <div className="mt-5 text-xs text-ink-muted">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
